class CollectionCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2.1,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            slides: {
              perView: 3.15,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg +
            1}px)`]: {
            slides: {
              perView: 3.15,
              spacing: 40,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els.dot.elements),
      ],
    )
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel)
}
